import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center gap-3" data-id="element-183">
        <div className="flex items-center gap-2 min-w-0" data-id="element-184">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full overflow-hidden bg-white ring-1 ring-slate-200 flex items-center justify-center shrink-0" data-id="element-185">
            <img src="https://cdn.magicpatterns.com/uploads/7kvJW8m3bLhnmJS1ZmPMSn/WhatsApp_Image_2026-06-09_at_09.43.25.jpg" alt="Logo Depilación Láser Uruguay" className="w-full h-full object-cover" data-id="element-186" />
          </div>
          <span className={`font-bold text-base sm:text-xl tracking-tight ${isScrolled ? 'text-navy-900' : 'text-navy-900 lg:text-white'}`} data-id="element-187">
            Depilación Láser Uruguay
          </span>
        </div>

        <a href={getWhatsAppUrl('Hola! Me gustaría agendar una consulta gratuita.')} target="_blank" rel="noopener noreferrer" className="shrink-0" data-id="element-188">
          <Button variant="whatsapp" size="sm" className="gap-1 sm:gap-2 text-[10px] sm:text-sm px-2 py-1 sm:px-4 sm:py-2" data-id="element-189">
            <MessageCircle className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-190" />
            <span className="hidden sm:inline" data-id="element-191">Agendar Consulta</span>
            <span className="sm:hidden" data-id="element-192">Agendar</span>
          </Button>
        </a>
      </div>
    </header>;
};